import ShopInfo from '@/entities/ShopInfo';

export default class ShopInfoTransformer {
  static transformOne(item) {
    return new ShopInfo(item);
  }

  static transformList(items) {
    return items.map((e) => ShopInfoTransformer.transformOne(e));
  }

  static getAddrString(addr) {
    return `${addr.street1} ${addr.street2}, ${addr.zip_code} ${addr.city}`;
  }
}
